// 전자계약 권한관리 동영상 가이드 manifest 런타임 로더(영상 URL·단계 시각·설명문)
//
// 왜 런타임 조회인가: manifest 를 빌드에 굳히면 가이드 영상이 바뀔 때마다
// 앱 재배포가 필요하다. Azure Blob의 포인터 manifest를 클릭 시점에 조회하면
// 가이드 개정이 "Blob 업로드 + 포인터 manifest 교체"만으로 끝난다(완전 무배포).
//
// 폴백 체인: 포인터(2초 타임아웃) → 번들 manifest.
// 포인터는 이 체계에서 유일하게 덮어쓰기가 허용되는 오브젝트다(콘텐츠는 버전 파일명 불변).
import bundledManifest from './videoGuide.manifest.json';

const POINTER_URL = 'https://certilife.blob.core.windows.net/certilife/guides/contract-view-policy/manifest.json';
const FETCH_TIMEOUT_MS = 2000;

let cached = null;

// 세션당 1회만 네트워크 조회하고 이후 클릭은 캐시를 쓴다.
export async function getVideoGuide() {
  if (cached) return cached;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    const res = await fetch(POINTER_URL, { signal: controller.signal, cache: 'no-cache' });
    clearTimeout(timer);
    if (res.ok) {
      const data = await res.json();
      if (data && typeof data.video === 'string' && data.video) {
        cached = data;
        return cached;
      }
    }
  } catch (e) {
    // 네트워크 실패·타임아웃 — 번들 폴백으로 조용히 넘어간다. 버튼은 죽지 않는다.
  }
  cached = bundledManifest;
  return cached;
}

// 초 단위를 "m:ss" 로 표시한다 (예: 348 → "5:48")
export function formatGuideDuration(sec) {
  if (typeof sec !== 'number' || Number.isNaN(sec)) return '';
  const total = Math.floor(sec);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
